/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  SEGMENT_GROUP_OPERATOR_LAST_ASSIGNED,
  SEGMENT_GROUP_OPERATOR_PRIORITY,
} from 'apps/customer-data-platform/src/Services/segmentation';

export enum SegmentGroupSwitcherOperator {
  ByRecency = SEGMENT_GROUP_OPERATOR_LAST_ASSIGNED,
  ByHierarchy = SEGMENT_GROUP_OPERATOR_PRIORITY,
}

export interface SegmentPriorityItem {
  id: string;
  name: string;
}
